import { Component, computed, inject, resource, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SimpleApi } from '@core/api/simple.api';
import { KonverteringUdtraek } from '../konvertering-udtraek.model';
import { KonverteringDatagridComponent } from '../konvertering-datagrid/konvertering-datagrid.component';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import { ButtonModule } from 'primeng/button';
import { downloadFromBlob } from '@core/api/api-utils';

@Component({
  selector: 'app-konvertering-show',
  imports: [
    ButtonModule,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    KonverteringDatagridComponent,
  ],
  templateUrl: './konvertering-show.component.html',
  styleUrl: './konvertering-show.component.css',
})
export class KonverteringShowComponent {
  simpleApi = inject(SimpleApi);
  private activatedRoute = inject(ActivatedRoute);
  id = signal('');
  activeTab = signal(0);

  constructor() {
    // Access route parameters
    this.activatedRoute.params.subscribe(params => {
      this.id.set(params['id']);
    });
  }

  data = resource({
    params: () => this.id(),
    loader: async ({ params, abortSignal }) => {
      return await this.simpleApi.getSingle<KonverteringUdtraek>(
        `/api/admin/konvertering/udtraek/${params}`,
        {},
        abortSignal
      );
    },
  });

  udtraekData = computed(() => {
    const dataAsString = this.data.value()?.queryData;
    if (dataAsString == null) return {} as Record<string, any[]>;
    const jsonData = JSON.parse(dataAsString);
    if (Array.isArray(jsonData)) {
      return { Data: jsonData } as Record<string, any[]>;
    } else {
      return jsonData as Record<string, any[]>;
    }
  });

  tabs = computed(() => {
    const tabsArray: UdtraekTab[] = [];

    let i = 0;
    for (const [key, value] of Object.entries(this.udtraekData())) {
      const tab: UdtraekTab = { tabName: key, tabIndex: i, tabData: value };
      tabsArray.push(tab);
      i++;
    }

    return tabsArray;
  });

  valorDate = computed(() => {
    const updatedAt = this.data.value()?.updatedAt;
    return updatedAt ? new Date(updatedAt).toLocaleDateString() : '';
  });

  async exportExcel() {
    const blob = await this.simpleApi.getBlob(
      `/api/admin/konvertering/udtraek/asexcel/${this.id()}`
    );
    downloadFromBlob(blob, 'Konvertering.xlsx');
  }
}

interface UdtraekTab {
  tabName: string;
  tabIndex: number;
  tabData: any[];
}
